  <div class="notices-container">
       <form [formGroup]="noticesForm">
          <mat-checkbox [ngClass]="{'m-b-1': !termsAndConditions.checked && nextClicked}" formControlName="termsAndConditions" #termsAndConditions (change)="onTermsChange($event)">
              <div>
                I have read and agree to the
                <a class="link-button" (click)="openTermsAndConditionsDialog($event)">Terms and Conditions</a>
              </div>
              @if(!termsAndConditions.checked && nextClicked){
                <mat-error>
                  You must accept the Terms and Conditions to proceed.
              </mat-error>
          }
          </mat-checkbox>
      </form>
        <a class="link-button" (click)="showSecurityPrivacyCookiePolicyModal()">About Data Security and Privacy</a>
</div>
